module.exports = __webpack_public_path__ + "static/media/angle-right.ea21d1ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/angle-right.svg
// module id = 273
// module chunks = 0